"use client";
import { useEffect } from 'react';
import axios from '../config/axios';

// Este componente garante que a sessão do usuário seja renovada periodicamente
export default function SessionKeepAlive() {
  useEffect(() => {
    // Function to check and renew session
    const pingSession = async () => {
      try {
        // Só enviar ping se houver token no localStorage
        const token = localStorage.getItem('authToken');
        if (token) {
          // Ping simples para renovar a sessão
          await axios.get('/auth/ping');
          console.log("Sessão atualizada com sucesso");
        }
      } catch (error) {
        console.log("Erro ao tentar manter sessão ativa:", error);
        // Não faremos nada em caso de erro - deixaremos o interceptor axios lidar com isso
      }
    };

    // Executar imediatamente e depois a cada 15 minutos
    pingSession();
    const interval = setInterval(pingSession, 15 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Este componente não renderiza nada
  return null;
}
